export type MarketingPlan = 'leader' | 'team';

/** Plan from the `?leader` / `?team` flag keys. Values such as a coupon ID never pick a plan. */
export const getMarketingPlan = (search: string): MarketingPlan | null => {
	const params = new URLSearchParams(search);
	if (params.has('leader')) return 'leader';
	if (params.has('team')) return 'team';
	return null;
};

/** Coupon ID from the `?coupon=` signup param. Ignores values that aren't a plausible Chargebee ID. */
export const getMarketingCoupon = (search: string): string | undefined => {
	const coupon = new URLSearchParams(search).get('coupon');
	return coupon && /^[\w.-]{1,100}$/.test(coupon) ? coupon : undefined;
};
